
export default function CostSection() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Transparent <span className="text-teal-600">Website Pricing</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We believe in honest, upfront pricing for El Paso small businesses. No hidden fees, 
            no surprises—just professional websites at fair prices.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-20">
          <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-gray-100 hover:border-teal-200 transition-colors duration-300">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Starter Website</h3>
              <div className="text-4xl font-bold text-teal-600 mb-2">$1,500</div>
              <div className="text-gray-600">Perfect for new businesses</div>
            </div>
            
            <ul className="space-y-3 mb-8">
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">5 custom pages</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Mobile-responsive design</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Basic SEO setup</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Contact form integration</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Google My Business setup</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">SSL certificate</span>
              </li>
            </ul>
            
            <a
              href="#contact"
              className="w-full bg-gray-100 hover:bg-gray-200 text-gray-900 px-6 py-3 rounded-lg font-semibold transition-colors duration-300 text-center block whitespace-nowrap cursor-pointer"
            >
              Get Started
            </a>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-teal-200 relative">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <div className="bg-teal-500 text-white px-6 py-2 rounded-full text-sm font-semibold">
                Most Popular
              </div>
            </div>
            
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Professional Website</h3>
              <div className="text-4xl font-bold text-teal-600 mb-2">$2,500</div>
              <div className="text-gray-600">Ideal for growing businesses</div>
            </div>
            
            <ul className="space-y-3 mb-8">
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">10 custom pages</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Advanced mobile optimization</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Complete SEO optimization</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Multiple contact forms</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Photo gallery integration</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Social media integration</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Analytics setup</span>
              </li>
            </ul>
            
            <a
              href="#contact"
              className="w-full bg-teal-500 hover:bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-300 text-center block whitespace-nowrap cursor-pointer"
            >
              Get Started
            </a>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-gray-100 hover:border-teal-200 transition-colors duration-300">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Enterprise Website</h3>
              <div className="text-4xl font-bold text-teal-600 mb-2">$4,000</div>
              <div className="text-gray-600">For established businesses</div>
            </div>
            
            <ul className="space-y-3 mb-8">
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Unlimited pages</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Custom functionality</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Advanced SEO strategy</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">E-commerce integration</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Online booking system</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Content management training</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">6 months free support</span>
              </li>
            </ul>
            
            <a
              href="#contact"
              className="w-full bg-gray-100 hover:bg-gray-200 text-gray-900 px-6 py-3 rounded-lg font-semibold transition-colors duration-300 text-center block whitespace-nowrap cursor-pointer"
            >
              Get Started
            </a>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-12 shadow-lg">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Why Our Pricing Makes Sense
              </h3>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Many El Paso businesses are surprised by our transparent pricing structure. Unlike other web 
                design companies that charge monthly fees or hide costs in contracts, we provide upfront pricing 
                with everything included.
              </p>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                Your investment includes design, development, hosting setup, SEO optimization, and training. 
                There are no recurring design fees—you own your website completely once it's launched.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-money-dollar-circle-line text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">No Hidden Fees</h4>
                    <p className="text-gray-600 text-sm">Everything is included in your quoted price—no surprises.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-hand-coin-line text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Flexible Payment Plans</h4>
                    <p className="text-gray-600 text-sm">50% deposit, 50% on completion. Payment plans available.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">100% Satisfaction Guarantee</h4>
                    <p className="text-gray-600 text-sm">We'll revise your website until you're completely happy.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/37e9b9d2327451aca8116c9414c7ed79.jpg"
                alt="Transparent website pricing for El Paso small businesses"
                className="w-full h-80 object-cover rounded-xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
